import { SystemField } from "./system-field";

export class GlobalPicklist extends SystemField { 
    name?:string;
    values?:string;
    description?:string;
    company_id?:string;
    icon?:string;
    picklist_type?:string;
    is_active?:number;
    ordering?:number;
    code?:number;
    label?:string;

    //relationship
    sub_picklists?:GlobalPicklist[];
    parent?:GlobalPicklist;
}
